import { DashboardAccess } from 'domain/entity/dashboard';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';
import { UpdateDashboardCriteria } from 'use-case/dashboard/update/updateDashboardCriteria';

export interface UpdateDashboardAccessCriteria extends UpdateDashboardCriteria {
    access: DashboardAccess;
}

class UpdateDashboardAccessCriteriaImpl implements UpdateDashboardAccessCriteria {
    constructor(readonly id: string, readonly access: DashboardAccess) {}
}

export class UpdateDashboardAccessCriteriaBuilder {
    private id: Option<string> = none;

    private access: Option<DashboardAccess> = none;

    static create = (): UpdateDashboardAccessCriteriaBuilder => new UpdateDashboardAccessCriteriaBuilder();

    withId = (id: string): UpdateDashboardAccessCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withAccess = (access: DashboardAccess): UpdateDashboardAccessCriteriaBuilder => {
        this.access = some(access);
        return this;
    };

    build = (): UpdateDashboardAccessCriteria => {
        if (isNone(this.id) || isNone(this.access)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateDashboardAccessCriteriaImpl(this.id.value, this.access.value);
    };
}
